module.exports = __webpack_public_path__ + "img/100-image-5.4d697823.png";